import { Box, Paper } from "@mui/material";
import styles from "./MyPublications.module.scss";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DataTable from "../../components/Table";
import { GridColDef } from "@mui/x-data-grid";
import StageComponent from "./StageComponent";
import workflowService from "../../services/workflow.service";
import { PublicationStage } from "../../models/workflow.model";
import { getLabel } from "../../misc/utils.functions";
import DocumentDownload from "../../components/DocumentDownload";
import StatusComponent from "./StatusComponent";

const MyPublications: React.FC = () => {
  const { t } = useTranslation();
  const [publications, setPublications] = useState<PublicationStage[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const columns: GridColDef[] = [
    {
      field: "title",
      headerName: getLabel("title"),
      sortable: false,
      minWidth: 150,
      flex: 1,
    },
    {
      field: "stage",
      headerName: getLabel("stage"),
      sortable: false,
      width: 120,
      renderCell: (params) => {
        return params.row.status === "InProgress" ? (
          <StageComponent
            workflowType={params.row.workflowType}
            stageCode={params.row.stageCode}
            stageStep={params.row.stageStep}
            isCompleted={params.row.isCompleted}
            waitingApproval={params.row.waitingApproval}
          />
        ) : (
          <StatusComponent statusCode={params.row.status} />
        );
      },
    },
    {
      field: "document",
      headerName: getLabel("document"),
      headerClassName: "document",
      sortable: false,
      cellClassName: "document",
      width: 70,
      renderCell: (params) => {
        return params.row.documents != null ? (
          <DocumentDownload documents={params.row.documents} />
        ) : (
          <></>
        );
      },
    },
  ];

  useEffect(() => {
    setLoading(true);
    workflowService.getMyLastPublications().then((publications) => {
      setPublications(publications);
      setLoading(false);
    });
  }, []);

  const handleRowClick = (row: PublicationStage) => {
    if (row.status === "InProgress") {
      navigate(`/summary/${row.ticketNumber}`);
    } else {
      navigate(`/publications/${row.ticketNumber}`);
    }
  };

  return (
    <Box className={styles.main}>
      <Paper elevation={3} className={styles.basic}>
        <div className={styles.header}>
          <h3>{t("myPublications")}</h3>
          <Link
            className={styles.viewAllLink}
            to="/MyInbox"
            preventScrollReset={false}
          >
            {t("viewAll")}
          </Link>
        </div>
        <DataTable<PublicationStage>
          rows={publications}
          columns={columns}
          handleRowClick={handleRowClick}
          emptyMessage={t("noRowsMessage", {
            entity: t("publications"),
          })}
          loading={loading}
        />
      </Paper>
    </Box>
  );
};

export default MyPublications;
